import type { VoidFunctionComponent } from 'react';

import DynamicShowMoreList from '../../../../../../generic/DynamicShowMoreList';
import type { Dependency } from '../../../../../../../../shared/dependenciesV2';

import { buildRichLicense, LicensingBadge, sortDeclaredLicenseFirst, unlicensedRichLicense } from './shared';

import styles from '../DetailsRow.module.less';

type Props = {
  // License IDs for the dependency
  licenses: string[];
  // Declared licenses for the dependency
  declaredLicenses: string[];
  // Issues on the dependency
  issues: Dependency['issues'];
};

/**
 * License section containing a list of licenses
 * @returns {React.ReactElement} License section
 */
const LicensingSection: VoidFunctionComponent<Props> = ({ licenses, declaredLicenses, issues }) => {
  const richLicenses = licenses
    .map((license) => buildRichLicense(license, declaredLicenses, issues))
    .sort(sortDeclaredLicenseFirst);

  if (richLicenses.length === 0) {
    richLicenses.push(unlicensedRichLicense);
  }

  const licenseElements = richLicenses.map((richLicense) => {
    return <LicensingBadge license={richLicense} key={richLicense.licenseId} />;
  });

  return (
    <div className={styles.licenseList}>
      <DynamicShowMoreList list={licenseElements} lineHeight={27} />
    </div>
  );
};

export default LicensingSection;
